import { Season } from '../models/season.model';

/**
 * Checks if a given season is currently active based on its start and end dates
 * @param season - The season to check
 * @returns boolean - true if the season is active, false otherwise
 */
export const isSeasonActive = (season: Season): boolean => {
  const now = new Date();
  const startDate = new Date(season.startDate);
  const endDate = new Date(season.endDate);

  return now >= startDate && now <= endDate;
};

/**
 * Finds a season by ID and checks if it's currently active
 * @param seasonId - The ID of the season to check
 * @param seasons - Array of all seasons
 * @returns boolean - true if the season exists and is active, false otherwise
 */
export const isSeasonActiveById = (
  seasonId: string | null,
  seasons: Season[] | null,
): boolean => {
  if (!seasonId || !seasons || seasons.length === 0) return false;

  const currentSeason = seasons.find((season) => season.seasonId === seasonId);
  if (!currentSeason) return false;

  return isSeasonActive(currentSeason);
};
